export default "__VITE_ASSET__BdxSwRaw__"